import { IPublicClientApplication } from "@azure/msal-browser";
import ProfessorParams from "../../model/params/ProfessorParams";

import { axiosGetRequest } from "../../api/ApiClient";

import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const route = "/docente/v1/professores";

async function getProfessores(
    msalInstance: IPublicClientApplication,
    professorParams: ProfessorParams
) {
    const params = StringUtils.getQueryParams(professorParams);

    return axiosGetRequest(
        `${route}${params}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getSporadicActivitiesByDocenteId(
    msalInstance: IPublicClientApplication,
    docenteId: number
) {
    return axiosGetRequest(
        `/docente/v1/docentes/${docenteId}/atividadesesporadicas`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getProfessorById(
    msalInstance: IPublicClientApplication,
    docenteId: number
) {
    return axiosGetRequest(
        `/docente/v1/docentes/${docenteId}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

async function getAvailableHours(
    msalInstance: IPublicClientApplication,
    docenteId: number,
    data: string
) {
    return axiosGetRequest(
        `/docente/v1/docentes/${docenteId}/horasdisponiveis?data=${data}`,
        GenericUtils.getAccessTokenDocente(),
        msalInstance
    );
}

export default {
    getProfessores,
    getSporadicActivitiesByDocenteId,
    getAvailableHours,
    getProfessorById,
};
